import React, { FC } from 'react';
import classNames from 'classnames';
import ReactCountryFlag from 'react-country-flag';
import styles from './BannerInner.module.scss';
import {
  ConfirmBookingIcon,
  AwaitBookingIcon,
  TooltipIcon,
} from '../../../assets/icons';
import {
  BookingFormType,
  BookingType,
} from '../../../redux/types/bookingTypes';
import { setModalWindowData } from '../../../redux/reducers/pageSlice';
import { ModalWindowTypes } from '../../../utils/@globalTypes';
import { useDispatch } from 'react-redux';
import useWindowDimensions from '../../../utils/useWindowDimensions';
import { setChessModalWindow } from '../../../redux/reducers/bookingSlice';

type BannerInnerProps = {
  booking: BookingType;
  bookingClassname: string;
  bannerWidth: number;
  left: number;
  isTooltip: boolean;
};

const BannerInner: FC<BannerInnerProps> = ({
  booking,
  bookingClassname,
  bannerWidth,
  left,
  isTooltip,
}) => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const roundSumSign: number = 2;

  const handlerViewBooking = () => {
    dispatch(
      setModalWindowData({
        type: ModalWindowTypes.SHOW_RESERVATION,
        data: { booking: booking, type: BookingFormType.view },
      }),
    );
  };
  const openModalWindow = () => {
    dispatch(
      setChessModalWindow({
        booking: booking,
        bookingClassName: bookingClassname,
      }),
    );
  };
  const totalCost: number =
    Number(booking.accommodation_price) +
    Number(booking.total_board_price) +
    Number(booking.total_animal_price);
  const top_lettering = 'Всего: ' + totalCost.toFixed(roundSumSign) + ' BYN';

  const bottom_lettering =
    'Долг: ' + (totalCost - +booking.paid).toFixed(roundSumSign) + ' BYN';
  const personLabel = `${booking.adult}+${booking.children ? booking.children.length : 0}`;

  return (
    <div
      className={classNames(
        styles.container,
        styles[bookingClassname],
        isTooltip && styles.tooltip,
      )}
      style={{ width: bannerWidth, left: left }}
      onClick={width > 600 ? handlerViewBooking : openModalWindow}
    >
      <div className={styles.left}>
        <div className={styles.statusIcon}>
          {booking.status === 'awt' && <AwaitBookingIcon />}
          {booking.status === 'cfm' && <ConfirmBookingIcon />}
        </div>
        <div className={styles.name}>
          <div>{booking.last_name}</div>
          <div>{booking.first_name}</div>
        </div>
        <div className={styles.flag}>
          <ReactCountryFlag
            svg
            countryCode={booking.nationality}
            style={{
              width: '2em',
              height: '1.2em',
            }}
          />
        </div>
      </div>

      <div className={styles.rigth}>
        <div className={styles.top}>{top_lettering}</div>
        <div className={styles.bottom}>{bottom_lettering}</div>
      </div>

      <div className={styles.tt_icon}>
        <span className={styles.count}>{personLabel}</span>
        <span className={styles.icon}>
          <TooltipIcon />
        </span>
      </div>
    </div>
  );
};

export default BannerInner;
